import React, { useEffect, useMemo, useState } from 'react';
import { useBhimaBulkData } from '../BhimaBulkDataContext';
import { getJSONObject } from 'utils/helper';
import { formatValueInRupees } from 'utils/currencyFormatter';

const BhimaStatCard = ({ title, value, subtext, apiParams }) => {
    const { dataByKey } = useBhimaBulkData();
    const [cardData, setCardData] = useState({ value, subtext });

    const response = useMemo(() => {
        if (apiParams?.chartid == null || apiParams?.dashboard_id == null) return null;
        return dataByKey[`${apiParams.dashboard_id}:${apiParams.chartid}`] ?? null;
    }, [dataByKey, apiParams?.dashboard_id, apiParams?.chartid]);

    useEffect(() => {
        if (!response) return;

        const result = response?.results?.[0];
        if (!result) return;

        if (result.error) {
            setCardData({ value: 'No data available', subtext: '' });
            return;
        }

        const dfData = getJSONObject(result.df_data);
        const rows = Array.isArray(dfData) ? dfData : [];
        let newValue = value;

        if (rows.length > 0) {
            const firstRow = rows[0];
            const values = Object.values(firstRow);
            if (values.length > 0) {
                newValue = values[0];
            }
        }

        if (apiParams?.chartid && [9, 10, 11, 12].includes(apiParams.chartid)) {
            if (newValue !== undefined && newValue !== null) {
                const strVal = String(newValue);
                if (!strVal.includes('₹') && !strVal.toLowerCase().includes('cr')) {
                    const numericValue = typeof newValue === 'string'
                        ? parseFloat(newValue.replace(/[^0-9.]/g, ''))
                        : Number(newValue);
                    if (!isNaN(numericValue)) {
                        const inCrores = numericValue / 10000000;
                        const formatted = new Intl.NumberFormat('en-IN', {
                            maximumFractionDigits: 2,
                            minimumFractionDigits: 0
                        }).format(inCrores);
                        newValue = `₹${formatted}Cr`;
                    }
                } else if (!strVal.includes('₹')) {
                    newValue = `₹${strVal}`;
                }
            }
        }

        setCardData((prev) => ({
            value: newValue !== undefined ? newValue : prev.value,
            subtext: result.subtext ?? prev.subtext
        }));
    }, [response, apiParams?.chartid, value]);

    const isNoData = cardData.value === 'No data available';

    return (
        <div className="bhima-card">
            <div className="bhima-card-title">{title}</div>
            {isNoData ? (
                <div className="bhima-no-data">No data available</div>
            ) : (
                <div className="bhima-card-value">{formatValueInRupees(cardData.value)}</div>
            )}
            {cardData.subtext && <div className="bhima-card-subtext">{cardData.subtext}</div>}
        </div>
    );
};

export default BhimaStatCard;
